import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiEndpoints } from "../../services/apiConfig"; // adjust path if needed

// ✅ Async thunk for submitting registration form
export const createCollage = createAsyncThunk(
    "collage/createCollage",
    async (formData, { rejectWithValue }) => {
        try {
            // Get token from localStorage
            const token = localStorage.getItem("token"); // replace "token" if your key is different

            const response = await axios.post(
                apiEndpoints.createCollage,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        // "Content-Type": "multipart/form-data",
                    },
                }
            );

            return response.data;
        } catch (error) {
            // Capture API or network errors
            return rejectWithValue(
                error.response?.data || { detail: "Something went wrong" }
            );
        }
    }
);

export const getAllCollage = createAsyncThunk(
    "collage/getAllCollage",
    async (_, { rejectWithValue }) => {
        try {
            // Get token from localStorage
            const token = localStorage.getItem("token"); // replace "token" if your key is different

            const response = await axios.get(
                apiEndpoints.getAllCollage,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            // Capture API or network errors
            return rejectWithValue(
                error.response?.data || { detail: "Something went wrong" }
            );
        }
    }
);

export const getCollageById = createAsyncThunk(
    "collage/getCollageById",
    async (orderId, { rejectWithValue }) => {
        try {
            // Get token from localStorage
            const token = localStorage.getItem("token");

            const response = await axios.get(
                apiEndpoints.getCollageById.replace("{order_id}", orderId),
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            // Capture API or network errors
            return rejectWithValue(
                error.response?.data || { detail: "Something went wrong" }
            );
        }
    }
);

export const downloadCollageById = createAsyncThunk(
  "collage/download",
  async (orderId, { rejectWithValue }) => {
    try {
      const res = await axios.get(apiEndpoints.downloadCollageById.replace("{order_id}", orderId), {
        responseType: "blob", 
      });

      return {
        blob: res.data,             
        contentType: res.headers["content-type"],
        contentDisposition: res.headers["content-disposition"],
      };
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);



// ✅ Slice definition
const collageSlice = createSlice({
    name: "collage",
    initialState: {
        loading: false,
        success: false,
        error: null,
        createCollageResponse: null,
        getAllCollageResponse: null,
        collageByIdResponse: null,
        downloadCollageByIdResponse: null,
    },
    extraReducers: (builder) => {
        builder
            .addCase(createCollage.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.error = null;
            })
            .addCase(createCollage.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.createCollageResponse = action.payload;
            })
            .addCase(createCollage.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.error = action.payload?.detail || "Submission failed";
            })
            .addCase(getAllCollage.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.error = null;
            })
            .addCase(getAllCollage.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.getAllCollageResponse = action.payload;
            })
            .addCase(getAllCollage.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.error = action.payload?.detail || "Submission failed";
            })
            .addCase(getCollageById.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.error = null;
            })
            .addCase(getCollageById.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.collageByIdResponse = action.payload;
            })
            .addCase(getCollageById.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.error = action.payload?.detail || "Submission failed";
            })
            .addCase(downloadCollageById.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.error = null;
            })
            .addCase(downloadCollageById.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.downloadCollageByIdResponse = action.payload;
            })
            .addCase(downloadCollageById.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.error = action.payload?.detail || "Submission failed";
            });
    },
});


export default collageSlice.reducer;
